<template>
  <div class="upload-logo mb-3" @click.stop="emitOpenManageLogosModal">
    <input
      type="file"
      :id="refName"
      @click="$event.target.value = ''"
      @change="handleAddNewLogosToBeUploaded()"
      :ref="refName"
      accept=".jpg,.jpeg,.png,.svg,.ai,.pdf"
    />
    <label :for="refName" class="flex flex-center align-center">
      <div class="label-hint">
        <template v-if="type === 'upload'">
          <div>
            <img
              src="~@/assets/icons/ui/cloud-upload-outline.svg"
              alt="upload"
            />
            <span class="text-center text-grey-dark">
              {{ graphicButtonHint }}
            </span>
          </div>
          <span class="allowed-formats"
            >JPG, PNG, SVG, AI, PDF (5MB Max)</span
          >
        </template>

        <template v-else>
          <img
            src="~@/assets/icons/ui/add-circle-outline-black.svg"
            alt="upload"
          />
          <span>Add Graphic</span>
        </template>
      </div>
    </label>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "UploadLogoButton",
  props: {
    graphicButtonHint: {
      type: String,
      default: "Upload Logo",
    },
    refName: {
      type: String,
      default: "logo-upload-input",
    },
    applyMode: {
      type: String,
      default: "project",
    },
    type: {
      type: String,
      default: "add", //add or upload
    },

    uploadToThreekit: {
      type: Boolean,
      default: true, //add or upload
    },
  },

  computed: { ...mapState(["dealer", "settings"]), ...mapGetters("project", ["isShowroom"]) },

  methods: {
    ...mapActions("uploadLogos", ["uploadLogos"]),
    ...mapActions("showroom", ["getDecorationsForSelectedCatalogLayouts"]),

    async handleAddNewLogosToBeUploaded() {
      const logosToBeUploaded = this.$refs[this.refName].files;

      await this.uploadLogos({
        logosToBeUploaded,
        applyMode: this.applyMode,
        uploadToThreekit: this.uploadToThreekit,
      });

      if (this.isShowroom) {
        this.getDecorationsForSelectedCatalogLayouts()
      }

    },

    emitUploadingLogo(file) {
      this.$emit("uploadingLogo", file);
    },

    emitLogoHasBeenUploaded(newLogo) {
      this.$emit("logoHasBeenUploaded", newLogo);
    },
    emitLogosHasBeenUploaded(newLogos) {
      this.$emit("logosHasBeenUploaded", newLogos);
    },

    emitOpenManageLogosModal() {
      this.hasCustomer && this.$emit("openManageLogosModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-logo {
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 1.2rem;
  }
  input[type="file"] {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  label {
    background-color: white;
    border: 0.780556px dashed $placeholder;
    border-radius: 6px;
    cursor: pointer;
    padding: 1rem;
    text-overflow: ellipsis;
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    width: 100%;
    .label-hint {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-right: 0.5rem;
      }
    }
    span {
      color: $placeholder;
      font-size: 1rem;
      line-height: 16px;
    }

    .allowed-formats {
      color: $placeholder;
      font-size: 0.75rem;
    }
  }
}
</style>
